export const NEW_HELP_TICKET_URL = '/help/support_tickets/new'
